import { styled } from "styled-components";

export const StyledCamelTop = styled.header`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1.6rem;
    margin-top: 3.2rem;
    width: 100%;
    height: 100%;
`;
